/* eslint-disable import/prefer-default-export */
import {
    DataGridSupportedFeatures,
} from '../SkyNetMasterDataGrid/SkyNetMasterDataGrid.types'
import {
    ColumnConfigMappingType,
    FilterOperatorType,
    SkyNetDataGridFilterType,
} from '../SkyBaseDataGrid/SkyBaseDataGrid.types'

export const featuresToHiddenColumns = (
    featuresLists: DataGridSupportedFeatures[],
): ColumnConfigMappingType[] => {
    if (featuresLists.includes(DataGridSupportedFeatures.ShowArchived, 0)) {
        return [{
            name: 'archived',
            minWidth: 50,
            sorting: false,
            filterable: false,
            filterType: SkyNetDataGridFilterType.Toggle,
            filterParams: {
                defaultValue: false,
                operator: FilterOperatorType.DataFilter,
            },
            headerName: 'Show Archived Only',
            hiddenFromColumns: true,
        }]
    }
    return []
}
